<template>
    <div>
        <el-breadcrumb>
            <el-breadcrumb-item style="padding-bottom: 30px"><span
                    style="font-weight: bolder">持仓分布数据（查询某一小时内的用户余额）</span></el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :model="condition" :inline="true" ref="conForm">
            <el-form-item label="钱包类型">
                <el-select v-model="condition.walletType">
                    <el-option v-for="item in walletTypes" :label="item.desc" :key="item.code" :value="item.code"/>
                </el-select>
            </el-form-item>
            <el-form-item label="用户类型">
                <el-select v-model="condition.role">
                    <el-option v-for="item in platformType" :label="item.desc" :key="item.code" :value="item.code"/>
                </el-select>
            </el-form-item>
            <el-form-item label="币种：">
                <el-input v-model="condition.coinType"/>
            </el-form-item>
            <el-form-item label="最小可用余额：">
                <el-input-number v-model="condition.minAv"/>
            </el-form-item>
            <el-form-item label="时间区间（某一小时内）：" prop="time"
                          :rules="[{required: true, message: '请输入交易时间', trigger: 'blur'}]">
                <el-date-picker v-model="condition.time" type="datetime" placeholder="选择某一小时"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="condition.page = 1,querySubmit()">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="exportData()">数据导出</el-button>
            </el-form-item>
            <el-form-item label="是否导出联系方式">
                <el-switch v-model="condition.contactWay" active-color="#13ce66" inactive-color="#ff4949"/>
            </el-form-item>
            <el-form-item v-if="condition.coinType">
                {{condition.coinType}} 可用与冻结总数 ：{{countAvFr(coinAccountList)}}
            </el-form-item>
            <el-form-item label="总人数：">
                {{coinAccountTotal}}
            </el-form-item>
        </el-form>

        <el-row>
            <el-col :span="20">
                <el-table :data="coinAccountList">
                    <el-table-column prop="id" label="ID" align="center"/>
                    <el-table-column prop="userId" label="用户ID" align="center"/>
                    <el-table-column prop="walletType" label="钱包类型">
                        <template slot-scope="scope">
                            {{parseDesc(scope.row.walletType,walletTypes)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="coinType" label="币种" align="center"/>
                    <el-table-column prop="coinAmount" label="可用余额" align="center"/>
                    <el-table-column prop="coinFroze" label="冻结余额" align="center"/>
                    <el-table-column prop="updateTime" label="更新时间" align="center" :formatter="dateFormat"/>
                </el-table>
            </el-col>
        </el-row>

        <br>
        <el-row>
            <el-col :span="12">
                <el-pagination background layout="total,prev, pager, next,sizes" :total="coinAccountTotal"
                               :page-size="25" :current-page="condition.page" :page-sizes="[25, 50, 100,200,1000,10000]"
                               @current-change="changePage" @size-change="handleSizeChange"/>
            </el-col>
        </el-row>

        <el-breadcrumb>
            <el-breadcrumb-item style="padding-top: 30px;padding-bottom: 30px"><span style="font-weight: bolder;">用户平均持仓成本/持仓量</span>
            </el-breadcrumb-item>
        </el-breadcrumb>
        <el-form label-width="150px" :inline="true">
            <el-form-item label="时间区间：" prop="positionTime"
                          :rules="[{required: true, message: '请输入交易时间', trigger: 'blur'}]">
                <el-date-picker v-model="positionTime" type="datetimerange" range-separator="至"
                                start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="positionPage = 1,queryUserPosition()">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="positionList">
            <el-table-column label="用户ID" prop="userId"></el-table-column>
            <el-table-column label="币种" prop="pair"></el-table-column>
            <el-table-column label="平均持仓成本" prop="price"></el-table-column>
            <el-table-column label="持仓量(买入量 - 卖出量)" prop="amount"></el-table-column>
        </el-table>
        <el-pagination background layout="total,prev, pager, next" :total="positionTotal" :page-size="25"
                       :current-page="positionPage" @current-change="changePagePosition"/>
    </div>
</template>

<script>
    import '../store';
    import moment from 'moment';
    import {mapState, mapActions} from 'vuex';
    import api from "../api";

    export default {
        name: "coinAccount",

        data() {
            return {
                condition: {
                    coinType: '',
                    time: '',
                    walletType: 'WALLET',
                    role: 0,
                    minAv: 0,
                    page: 1,
                    size: 25,
                    contactWay: false,
                },

                positionTime: [],
                positionPage: 1,
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '当天',
                            onClick(picker) {
                                const end = new Date();
                                let year = end.getFullYear();
                                let month = end.getMonth();
                                let date = end.getDate();
                                const start = new Date(year, month, date);
                                start.setTime(start.getTime());
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近三天',
                            onClick(picker) {
                                const end = new Date();
                                let year = end.getFullYear();
                                let month = end.getMonth();
                                let date = end.getDate();
                                const start = new Date(year, month, date);
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                let year = end.getFullYear();
                                let month = end.getMonth();
                                let date = end.getDate();
                                const start = new Date(year, month, date);
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                    ]
                },
                walletTypes: [{code: 'WALLET', desc: '现货账户'}, {code: 'MARGIN', desc: '杠杆账户'}, {
                    code: 'OTC',
                    desc: '法币账户'
                }, {code: 'CONTRACT', desc: '合约账户'}, {code: 'GENERAL', desc: '超级合约'}],
                platformType: [{code: 1, desc: '平台用户'}, {code: 0, desc: '非平台用户'}, {code: 2, desc: '市值账户'}],
            }
        },

        computed: {
            ...mapState('tradeStatistic', ['coinAccountList', 'coinAccountTotal', 'positionTotal', 'positionList', 'snapPosition'])
        },

        methods: {
            ...mapActions('tradeStatistic', ['getCoinAccountList', 'exportCoinAccountData', 'getUserPosition', 'buildSnapPosition']),

            querySubmit() {
                this.$refs['conForm'].validate(valid => {
                    if (valid) {
                        this.getCoinAccountList(this.condition);
                    }
                })
            },

            exportData() {
                this.$refs['conForm'].validate(valid => {
                    if (valid) {
                        //先查询总条数
                        api.countSpotAccount(this.condition).then(response => {
                            let count = response.data;
                            let size = 4000;
                            this.foreachDownload(count,size);
                        })
                    }
                })
            },

            async foreachDownload(count,size) {
                for (let i = 1; (i - 1) * size < count; i++) {
                    this.condition.pageNo = i;
                    this.condition.size = size;
                    await this.downloadExcel();
                }
            },

            downloadExcel() {
                 return this.exportCoinAccountData(this.condition).then(response2 => {
                    const fileName = "持仓分布数据表" + this.condition.time + ".xlsx";
                    const blob = new Blob([response2], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                });
            },

            changePage(pageNo) {
                this.condition.page = pageNo;
                this.querySubmit();
            },

            dateFormat(row, column) {
                return moment(row.updateTime).format("YYYY-MM-DD HH:mm:ss")
            },

            queryUserPosition() {
                let data = {
                    page: this.positionPage,
                    startTime: this.positionTime[0],
                    endTime: this.positionTime[1]
                }
                this.getUserPosition(data);
            },

            changePagePosition(pageNo) {
                this.positionPage = pageNo;
                this.queryUserPosition();
            },

            parseDesc(code, list) {
                for (let i in list) {
                    if (code === list[i].code) {
                        return list[i].desc;
                    }
                }
            },
            handleSizeChange(val) {
                this.condition.size = val;
            },

            countAvFr(coinAccountList) {
                let count = 0;
                for (let i in coinAccountList) {
                    let currentInfo = coinAccountList[i];
                    count = currentInfo.coinAmount + currentInfo.coinFroze + count;
                }
                return count;
            }
        },

        created() {
            let time = new Date();
            let year = time.getFullYear();
            let month = time.getMonth();
            let day = time.getDate();
            this.positionTime[0] = new Date(year, month, day, 0, 0, 0);
            this.positionTime[1] = new Date(year, month, day, 23, 59, 59);
        },
    }
</script>

<style scoped>

</style>
